import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { GulfstreamGlyph, HuracanGlyph, SpeedboatGlyph } from './RequestIcons';

// Each vehicle leaves the way it moves: the jet climbs away, the car accelerates
// straight out, the boat skims off over the water. The next one glides in from
// behind and settles. A fine light streak traces the handover.
const vehicles = [{
  Glyph: GulfstreamGlyph,
  exit: {
    x: 26,
    y: -9,
    rotate: -8
  }
}, {
  Glyph: HuracanGlyph,
  exit: {
    x: 30,
    y: 0,
    rotate: 0
  }
}, {
  Glyph: SpeedboatGlyph,
  exit: {
    x: 26,
    y: 1.5,
    rotate: -3
  }
}];

// Opening run: a quick pass jet → car → boat → jet, then one change every few seconds
const introSteps = 4;
const introInterval = 900;
const restInterval = 4200;
const easeOut = [0.23, 1, 0.32, 1] as const;
const easeAway = [0.55, 0, 0.75, 0.2] as const;
type TransitGlyphCycleProps = {
  className?: string;
  startDelay?: number;
};
export function TransitGlyphCycle({
  className = '',
  startDelay = 900
}: TransitGlyphCycleProps) {
  const reduced = useReducedMotion();
  const [step, setStep] = useState(0);
  useEffect(() => {
    if (reduced) return;
    const wait = step === 0 ? startDelay + introInterval : step < introSteps ? introInterval : restInterval;
    const t = window.setTimeout(() => setStep(s => s + 1), wait);
    return () => window.clearTimeout(t);
  }, [step, reduced, startDelay]);
  const index = step % vehicles.length;
  const {
    Glyph,
    exit
  } = vehicles[index];
  return <span className={`relative inline-flex overflow-hidden ${className}`} data-id="element-1196" data-mp="2i9ifmqk3l4ss">
      {/* Light streak across the handover */}
      {step > 0 && <motion.span key={`streak-${step}`} aria-hidden="true" className="pointer-events-none absolute left-0 right-0 top-[62%] h-px origin-left bg-current" initial={{
      scaleX: 0,
      opacity: 0.5
    }} animate={{
      scaleX: [0, 1, 1],
      opacity: [0.5, 0.35, 0]
    }} transition={{
      duration: 0.3,
      ease: easeOut,
      times: [0, 0.6, 1]
    }} data-id="element-1197" data-mp="2s8hp2bcot4gu" />}
      <AnimatePresence initial={false} mode="popLayout" data-id="element-1198" data-mp="1rk7go3s92223">
        <motion.span key={index} className="flex h-full w-full" initial={{
        opacity: 0,
        x: -22,
        scale: 0.96,
        filter: 'blur(2px)'
      }} animate={{
        opacity: 1,
        x: 0,
        y: 0,
        rotate: 0,
        scale: 1,
        filter: 'blur(0px)'
      }} exit={{
        ...exit,
        opacity: 0,
        filter: 'blur(2px)',
        transition: {
          duration: 0.24,
          ease: easeAway
        }
      }} transition={{
        duration: 0.3,
        ease: easeOut,
        delay: 0.08
      }} data-id="element-1199" data-mp="1rkz4gsfluvht">
          <Glyph className="h-full w-full" data-id="element-1200" data-mp="2f9s0sq0535cy" />
        </motion.span>
      </AnimatePresence>
    </span>;
}